import type { JSX } from 'react';
import React from 'react';

import type { OnboardingTask } from '@feathr/blackbox';
import { EOnboardingMilestone } from '@feathr/blackbox';
import { Checkbox } from '@feathr/components';

import type { ITaskConfig } from '../OnboardingPage/MilestonePage/MilestoneTasks/MilestoneTasks.types';

interface IArgs {
  tasks: OnboardingTask[];
  selectedMilestones: EOnboardingMilestone[];
  selectedTasks: OnboardingTask[];
  isGlobal: boolean;
  isResetting: boolean;
  handleSelectTask: (task: OnboardingTask) => void;
}

interface IAccountSetupArgs extends IArgs {
  accountMilestones: ITaskConfig[];
}

interface IEmailCampaignArgs extends IArgs {
  emailMilestones: ITaskConfig[];
}

export function renderAccountSetupTasks({
  tasks,
  selectedMilestones,
  selectedTasks,
  isGlobal,
  isResetting,
  accountMilestones,
  handleSelectTask,
}: IAccountSetupArgs): JSX.Element[] {
  return tasks
    .filter((t) => t.get('milestone') === EOnboardingMilestone.InitialAccountSetup)
    .map((t) => {
      return (
        <Checkbox
          disabled={
            selectedMilestones.includes(EOnboardingMilestone.InitialAccountSetup) ||
            !isGlobal ||
            isResetting
          }
          key={t.id}
          label={accountMilestones.find((m) => m.taskType === t.get('type'))?.title}
          onChange={(): void => handleSelectTask(t)}
          value={
            selectedMilestones.includes(EOnboardingMilestone.InitialAccountSetup) ||
            selectedTasks.includes(t)
          }
        />
      );
    });
}

export function renderEmailCampaignTasks({
  tasks,
  selectedMilestones,
  selectedTasks,
  isGlobal,
  isResetting,
  emailMilestones,
  handleSelectTask,
}: IEmailCampaignArgs): JSX.Element[] {
  return tasks
    .filter((t) => t.get('milestone') === EOnboardingMilestone.SingleSendCampaign)
    .map((t) => {
      return (
        <Checkbox
          disabled={
            selectedMilestones.includes(EOnboardingMilestone.SingleSendCampaign) ||
            !isGlobal ||
            isResetting
          }
          key={t.id}
          label={emailMilestones.find((m) => m.taskType === t.get('type'))?.title}
          onChange={(): void => handleSelectTask(t)}
          value={
            selectedMilestones.includes(EOnboardingMilestone.SingleSendCampaign) ||
            selectedTasks.includes(t)
          }
        />
      );
    });
}
